export default __webpack_public_path__ + "static/media/feed5.1ae8ba6d.jpg";